module.exports = __webpack_public_path__ + "static/media/doubleDog4.4c6b1573.png";